
import Vue, { VNode } from "vue";
import JzContainer from "./JzContainer.vue";

interface Data {
  (): { activeIndex: number };
}

interface Methods {
  activeTab(): VNode;
  handleTabTitleClick(index: number): () => void;
  tabTitles(): VNode;
}

interface Props {
  activeTabIndex: number;
}

interface TabProps {
  title: string;
  count: string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "JzTabs",
  components: {
    JzContainer
  },
  props: {
    activeTabIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      activeIndex: this.$props.activeTabIndex || 0,
      tabs: []
    };
  },
  methods: {
    activeTab() {
      const slotContents = this.$slots.default || [];

      return slotContents[this.$data.activeIndex];
    },
    handleTabTitleClick(index: number) {
      return () => {
        this.$data.activeIndex = index;
      };
    },
    tabTitles() {
      const slotContents = this.$slots.default || [];
      const titles: VNode[] = [];

      slotContents.forEach((item, index) => {
        const options = item.componentOptions;
        if (options) {
          const { title, count } = options.propsData as TabProps;
          titles.push(
            this.$createElement(
              "span",
              {
                class: { selected: this.$data.activeIndex === index },
                on: {
                  click: this.handleTabTitleClick(index)
                },
                staticClass: "tab-title"
              },
              [title]
            )
          );

          if (count) {
            titles.push(
              this.$createElement(
                "span",
                {
                  staticClass: "tab-count"
                },
                [count]
              )
            );
          }
        }
      });

      return this.$createElement(
        JzContainer,
        { staticClass: "tab-titles" },
        titles
      );
    }
  },

  render(h): VNode {
    const titles = this.tabTitles();
    const tab = this.activeTab();

    return h(
      "div",
      {
        staticClass: "jz-tabs"
      },
      [titles, tab]
    );
  }
});
